import { useMutation } from "react-query";
import { sendRequest } from "../sendRequest";

export const reConnectIg = async ({ data, token }) => {
  const response = await sendRequest(
    "post",
    "/influencer/social-media-access/instagram/reauth",
    { ...data },
    {
      Authorization: `Bearer ${token}`,
    }
  );
  return response;
};

export default function useReConnectIg() {
  return useMutation(reConnectIg);
}
